// Copyright © 2021 Move Closer
import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export class LabelDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = RelatedType.Label;
    }
}
